import React from 'react';

const IconTwitterSquare: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='25'
    height='26'
    viewBox='0 0 25 26'
    focusable='false'
    role='presentation'
    fill='none'
    {...props}
    className={`icon icon-twitter-square${props.className ? ' ' + props.className : ''}`}
  >
    <path
      d='M22.3214 0.5H2.67857C1.19978 0.5 0 1.69978 0 3.17857V22.8214C0 24.3002 1.19978 25.5 2.67857 25.5H22.3214C23.8002 25.5 25 24.3002 25 22.8214V3.17857C25 1.69978 23.8002 0.5 22.3214 0.5ZM19.5926 9.36161C19.6038 9.51786 19.6038 9.67969 19.6038 9.83594C19.6038 14.6741 15.9208 20.2489 9.19085 20.2489C7.11496 20.2489 5.18973 19.6462 3.57143 18.6083C3.86719 18.6417 4.15179 18.6529 4.45313 18.6529C6.1663 18.6529 7.73996 18.0725 8.99554 17.0904C7.38839 17.0569 6.03795 16.0022 5.57478 14.5513C6.13839 14.635 6.64621 14.635 7.22656 14.4844C5.55246 14.144 4.29688 12.6708 4.29688 10.8906V10.846C4.78237 11.1194 5.35156 11.2868 5.94866 11.3092C5.44667 10.9752 5.03515 10.5223 4.75082 9.9906C4.4665 9.45895 4.31821 8.86518 4.3192 8.26228C4.3192 7.58147 4.49777 6.95647 4.81585 6.41518C6.6183 8.63616 9.32478 10.0871 12.3605 10.2433C11.8415 7.76005 13.6998 5.74554 15.9319 5.74554C16.9866 5.74554 17.9353 6.18638 18.6049 6.90067C19.4308 6.74442 20.2232 6.4375 20.9263 6.01897C20.6529 6.86719 20.0781 7.58147 19.3192 8.03348C20.0558 7.95536 20.7701 7.74888 21.4286 7.46429C20.9319 8.19531 20.3069 8.84263 19.5926 9.36161Z'
      fill=''
    />
  </svg>
);
export default IconTwitterSquare;
